import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';

interface IDividerProps {
  className?: ClassValue;
  vertical?: boolean;
}
export default function Divider({ className, vertical }: IDividerProps) {
  return (
    <span
      className={cn(
        'border-border-default my-1 w-full border-t',
        vertical && 'mx-1 w-[1px] border-t-0 border-r',
        className,
      )}
    ></span>
  );
}
